import React from "react";
import SequenceRead from "../../sequence/SequenceRead";
import { MOMENTUM } from "./config";

// The Momentum Read: the shared motion Read flow with Momentum's examples and
// copy (config.js).
export default function MomentumRead() {
  return <SequenceRead read={MOMENTUM} />;
}
